/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Button, Cell, Grid, Heading, HFlow, Icon, Text, Tooltip, VFlow } from 'bold-ui'
import { Fragment, useState } from 'react'
import { EditableRow } from 'view/atendimentos/detail/components/EditableList'

import { OutrosFieldModel } from './OutrosField'
import OutrosForm from './OutrosForm'

export interface OutrosTableRowProps {
  item: OutrosFieldModel
  cidadaoDataNascimento: LocalDate
  updateItem(item: OutrosFieldModel): void
  removeItem(item: OutrosFieldModel): void
  readonly?: boolean
}

type OutrosTableRowState = 'default' | 'editing'

export default function OutrosTableRow(props: OutrosTableRowProps) {
  const { item, cidadaoDataNascimento, readonly, updateItem, removeItem } = props
  const [state, setState] = useState<OutrosTableRowState>('default')

  const handleSubmitEdicao = (values: OutrosFieldModel) => {
    updateItem(values)
    setState('default')
  }

  return (
    <EditableRow editing={state === 'editing'}>
      {state === 'default' ? (
        <Fragment>
          <Grid
            style={css`
              margin: 0;
            `}
          >
            <Cell size={4} alignSelf='center'>
              <Text>{item.local}</Text>
            </Cell>

            <Cell size={6} alignSelf='center'>
              {item.procedimentos.map((proced) => (
                <Text key={proced.id}>
                  {proced.descricao} - {proced.codigo}
                  <br />
                </Text>
              ))}
            </Cell>

            {!readonly && (
              <Cell size={2} alignSelf='center'>
                <HFlow hSpacing={0.5} justifyContent='flex-end'>
                  <Tooltip text='Editar'>
                    <Button size='small' skin='ghost' onClick={() => setState('editing')}>
                      <Icon icon='penOutline' />
                    </Button>
                  </Tooltip>
                  <Tooltip text='Excluir'>
                    <Button size='small' skin='ghost' onClick={() => removeItem(item)}>
                      <Icon icon='trashOutline' />
                    </Button>
                  </Tooltip>
                </HFlow>
              </Cell>
            )}
          </Grid>
          {!!item?.observacao?.trim().length && (
            <HFlow
              hSpacing={0.2}
              style={css`
                padding-bottom: 0.5rem;
              `}
            >
              <Text fontWeight='bold'>Observações: </Text>
              <Text
                fontStyle='italic'
                style={css`
                  word-break: break-all;
                `}
              >
                <div dangerouslySetInnerHTML={{ __html: item.observacao }} />
              </Text>
            </HFlow>
          )}
        </Fragment>
      ) : (
        <VFlow
          style={css`
            padding: 1rem 0;
          `}
        >
          <Heading level={4}>Editar procedimentos (evoluções odontológicas) de outros locais</Heading>

          <OutrosForm
            editing={true}
            cidadaoDataNascimento={cidadaoDataNascimento}
            initialValues={item}
            onSubmit={handleSubmitEdicao}
            onCancel={() => setState('default')}
          />
        </VFlow>
      )}
    </EditableRow>
  )
}
